@let userName = userName$ | async;
@let canImpersonate = canImpersonate$ | async;
@let isImpersonating = impersonating$ | async;
@let impersonatingDisplay = impersonatingName$ | async;

<button matButton
        [matMenuTriggerFor]="logoutMenu"
>
    <mat-icon>account_circle</mat-icon>
    <span class="user-name">{{ userName || 'Utilisateur' }}</span>
    @if (canImpersonate) {
        &nbsp;<span>({{ impersonatingDisplay }})</span>
    }
</button>

<mat-menu #logoutMenu="matMenu"
          [xPosition]="'before'"
>
    @if (canImpersonate) {
        <button mat-menu-item
                (click)="impersonate$.next()">
            <mat-icon>badge</mat-icon>
            {{ "shared.actions.impersonate" | ubbTranslate | async }}
        </button>
        <button mat-menu-item
                class="warn-icon"
                [disabled]="!isImpersonating"
                (click)="stopImpersonate$.next()">
            <mat-icon>highlight_off</mat-icon>
            {{ "shared.actions.stop-impersonate" | ubbTranslate | async }}
        </button>
    }
    <button mat-menu-item routerLink="/workspace/account">
        <mat-icon>manage_accounts</mat-icon>
        <span>{{ "shared.actions.manage-account" | ubbTranslate | async }}</span>
    </button>
    <button mat-menu-item routerLink="/workspace/account" [queryParams]="{ tab: 'notifications' }">
        <mat-icon>notifications_active</mat-icon>
        <span>{{ "shared.actions.my-notifications" | ubbTranslate | async }}</span>
    </button>
    <button mat-menu-item (click)="logout$.next()">
        <mat-icon>logout</mat-icon>
        <span>{{ "shared.actions.logout" | ubbTranslate | async }}</span>
    </button>
</mat-menu>
